import { AssemblyPaymentsService }      from './assembly-payments.service.ajs';
import { AssemblyPaymentTerminalModel } from './models/assembly-payment.terminal';

export function AssemblyPaymentsPairCtrl (
  $scope             : any,
  $uibModalInstance  : ng.ui.bootstrap.IModalInstanceService,
  assemblyPaymentsApi: AssemblyPaymentsService,
  terminal           : AssemblyPaymentTerminalModel
) {
  $scope.currentTerminal   = assemblyPaymentsApi.getTerminal();
  $scope.messsage          = '';
  $scope.pairingSuccessful = false;
  $scope.showConfirmCode   = false;
  $scope.terminal          = terminal;

  if ($scope.currentTerminal) {
    $scope.terminal.secrets = {
      EncKey : $scope.terminal.ap_terminal_key,
      HmacKey: $scope.terminal.ap_hmac_key
    };
  }

  if (!assemblyPaymentsApi.spiApi) {
    assemblyPaymentsApi.initializeSpi($scope.terminal);
  }

  $scope.cancel = function() {
    assemblyPaymentsApi.spiApi.PairingCancel();

    $uibModalInstance.close();
  };

  $scope.handleDeviceAddressChanged = function ( e : CustomEvent ) {
    assemblyPaymentsApi.spiApi._eftposAddress = e.detail.Address;
  };

  $scope.handlePairingFlowStateChanged = function ( e : CustomEvent ) {
    $scope.message = e.detail.Message;

    if (e.detail.ConfirmationCode && e.detail.AwaitingCheckFromPos) {
      $scope.message = `${ e.detail.Message }\n\n${ e.detail.ConfirmationCode }`;
    }

    $scope.showConfirmCode = e.detail.AwaitingCheckFromPos;

    if (e.detail.Successful && e.detail.Finished) {
      $scope.pairingSuccessful = true;
      $scope.showConfirmCode   = false;

      assemblyPaymentsApi.spiApi.AckFlowEndedAndBackToIdle();
    }

    if(!$scope.$$phase) {
      $scope.$apply();
    }
  };

  $scope.handleSecretsChanged = function ( e : CustomEvent ) {
    $scope.currentTerminal = assemblyPaymentsApi.getTerminal();

    if (e.detail) {
      if (e.detail.EncKey && $scope.currentTerminal) {
        $scope.currentTerminal = angular.extend($scope.terminal, $scope.currentTerminal);

        $scope.currentTerminal.alternate_ip_address = assemblyPaymentsApi.spiApi._eftposAddress;
        $scope.currentTerminal.secrets              = e.detail;
      }
      else if (e.detail.EncKey && !$scope.currentTerminal) {
        $scope.currentTerminal = $scope.terminal;

        $scope.currentTerminal.alternate_ip_address = assemblyPaymentsApi.spiApi._eftposAddress;
        $scope.currentTerminal.status               = '';
        $scope.currentTerminal.secrets              = e.detail;
      }

      assemblyPaymentsApi.storeTerminal($scope.currentTerminal);
    };
  };

  $scope.handleStatusChanged = function ( e : CustomEvent ) {
    $scope.currentTerminal = assemblyPaymentsApi.getTerminal();

    if ($scope.currentTerminal) {
      if ($scope.currentTerminal.status !== e.detail) {
        $scope.currentTerminal.status = e.detail;

        assemblyPaymentsApi.storeTerminal($scope.currentTerminal);
      };
    } else {
      $scope.currentTerminal = $scope.terminal;

      $scope.currentTerminal.alternate_ip_address = assemblyPaymentsApi.spiApi._eftposAddress;
      $scope.currentTerminal.status               = e.detail;
    }

    assemblyPaymentsApi.storeTerminal($scope.currentTerminal);
  };

  $scope.pairCodeCorrect = function() {
    assemblyPaymentsApi.spiApi.PairingConfirmCode();
  };

  $scope.pairCodeIncorrect = function() {
    assemblyPaymentsApi.spiApi.PairingCancel();
  };

  document.addEventListener('DeviceAddressChanged', $scope.handleDeviceAddressChanged);
  document.addEventListener('PairingFlowStateChanged', $scope.handlePairingFlowStateChanged);
  document.addEventListener('SecretsChanged', $scope.handleSecretsChanged);
  document.addEventListener('StatusChanged', $scope.handleStatusChanged);

  assemblyPaymentsApi.spiApi.Pair();

  $scope.$on('$destroy', () => {
    document.removeEventListener('DeviceAddressChanged', $scope.handleDeviceAddressChanged);
    document.removeEventListener('PairingFlowStateChanged', $scope.handlePairingFlowStateChanged);
    document.removeEventListener('SecretsChanged', $scope.handleSecretsChanged);
    document.removeEventListener('StatusChanged', $scope.handleStatusChanged);
  });
}